import * as actions from '@/modules/surveys'
import { fetchNextPageAction, responseToState } from '@/store/pagination'

export const fetchSurveys = async ({ commit, dispatch }, params) => {
  if (!params.page || params.page === 1) {
    commit('resetPagination');
  }

  const response = await actions.fetchSurveys(params);

  response.data.forEach(data => dispatch('upsertSurvey', data))

  commit('updatePagination', responseToState(response, params));

  return response;
}

export const fetchNextPage = fetchNextPageAction('fetchSurveys');

export const fetchSurvey = async ({ dispatch, rootGetters }, id) => {

  if (rootGetters['fetching/isFetching'](id)) {
    return await rootGetters['fetching/getRequest'](id);
  }

  const request = actions.fetchSurvey(id);

  const response = await dispatch('fetching/doRequest', { id, request }, { root: true })

  dispatch('upsertSurvey', response.data)

  return response;
}

export const fetchSurveysResume = async ({ dispatch, commit, rootGetters }) => {
  const requestId = 'surveys-resume';

  if (rootGetters['fetching/isFetching'](requestId)) {
    return await rootGetters['fetching/getRequest'](requestId);
  }

  const request = actions.fetchSurveysRating();

  const response = await dispatch('fetching/doRequest', { id: requestId, request }, { root: true });

  commit('setResume', response.data);

  return response;
}

export const upsertSurvey = async ({ commit }, data) => {

  const { ...refund } = data;

  commit('upsertOne', refund)
}

export default {
  fetchSurveys,
  fetchNextPage,
  fetchSurvey,
  fetchSurveysResume,
  upsertSurvey
}
